import { DataHeader, DataSource, HorizontalSpacer, Layout, Location, Panel, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutQuoteList extends Layout {
    dataheader1: DataHeader;
    horizontalspacer1: HorizontalSpacer;
    panelLeft: Panel;
    panelQuoteListContainer: Panel;
    panelRight: Panel;
    panelSearchTop: Panel;
    searchpanelSearchQuotes: SearchPanel;
    sourceQuoteOrder: DataSource;
    tableQuoteList: Table;
    textboxCustomerName: Textbox;
    textboxDeliveryDateRange: Textbox;
    textboxDestLocation: Location;
    textboxEffectiveDate: Textbox;
    textboxEnteredUserId: Textbox;
    textboxId: Textbox;
    textboxOrderMode: Textbox;
    textboxOrderTypeId: Textbox;
    textboxOrderedDate: Textbox;
    textboxOrderedMethod: Textbox;
    textboxOriginLocation: Location;
    textboxPickupDateRange: Textbox;
    textboxRevenueCodeId: Textbox;
    textboxSalespersonId: Textbox;
}
